import { adminDashboardCheckMarquee, adminDashboardTatData, getChecksList, CheckInteractivity, GetStatusCounts, GetAccessData, GetPreOnboardingCandidatesList } from "../actions/AdminDashboardAction";
import { createSlice } from "@reduxjs/toolkit";

const adminDashboardCheckMarqueeSlice = createSlice({
  name: "adminDashboardCheckMarquee",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminDashboardCheckMarquee.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminDashboardCheckMarquee.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(adminDashboardCheckMarquee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const adminDashboardTatDataSlice = createSlice({
  name: "adminDashboardTatData",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(adminDashboardTatData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminDashboardTatData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(adminDashboardTatData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const getChecksListSlice = createSlice({
  name: "getChecksList",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getChecksList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getChecksList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(getChecksList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const CheckInteractivitySlice = createSlice({
  name: "CheckInteractivity",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(CheckInteractivity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(CheckInteractivity.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(CheckInteractivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const GetStatusCountsSlice = createSlice({
  name: "GetStatusCounts",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetStatusCounts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetStatusCounts.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(GetStatusCounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const GetAccessDataSlice = createSlice({
  name: "GetAccessData",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAccessData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetAccessData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(GetAccessData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

const GetPreOnboardingCandidatesListSlice = createSlice({
  name: "GetPreOnboardingCandidatesList",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetPreOnboardingCandidatesList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetPreOnboardingCandidatesList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // Call the success callback if provided
        if (typeof action.meta.arg.successFn === "function") {
          action.meta.arg.successFn(action.payload);
          console.log("action page", action.payload);
        }
      })
      .addCase(GetPreOnboardingCandidatesList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        // Call the failure callback if provided
        if (typeof action.meta.arg.failureFn === "function") {
          action.meta.arg.failureFn(action.error.message);
          console.log("action:::", action.error.message);
        }
      });
  },
});

export const reducers = {
  adminDashboardCheckMarquee: adminDashboardCheckMarqueeSlice.reducer,
  adminDashboardTatData: adminDashboardTatDataSlice.reducer,
  getChecksList: getChecksListSlice.reducer,
  CheckInteractivity: CheckInteractivitySlice.reducer,
  GetStatusCounts: GetStatusCountsSlice.reducer,
  GetAccessData: GetAccessDataSlice.reducer,
  GetPreOnboardingCandidatesList: GetPreOnboardingCandidatesListSlice.reducer,
};
